import {post} from '../script/serviceApiPost';

export default{
  
  async save(requestParam: any) {
    const result = await post('tbUser/save', requestParam);
    return result;
  },
  async removeByIds(requestParam: any) {
    const result = await post('tbUser/removeByIds', requestParam);
    return result;
  },
  async updateById(requestParam: any) {
    const result = await post('tbUser/updateById', requestParam);
    return result;
  },
  async getById(requestParam: any) {
    const result = await post('tbUser/getById', requestParam);
    return result;
  },
  async selectPageData(dataRow: any) {
    const result = await post('tbUser/selectPageData', dataRow);
    return result;
  },
  
};
